module.exports = __webpack_public_path__ + "img/mobile__fondo__login.ed40643f.svg";